// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Qra3d","iconContainer":"Button_iconContainer__SYuvn","margin":"Button_margin__o6Ir9","textButton":"Button_textButton__DnKI1","active":"Button_active__3Lzyu"};